import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { NoteCode } from '@user/components/Notes/typings'
import MenuItem from '@mui/material/MenuItem'
import { Field } from 'formik'
import * as React from 'react'

type Props = {
  name: string
  label?: string
  required?: boolean
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  value: string | null
  options: NoteCode[]
  selectWidth?: string
  error: string | boolean | undefined
}

export default (props: Props) => {
  const {
    name,
    label,
    required,
    options,
    value,
    setFieldValue,
    selectWidth,
    error,
  } = props

  return (
    <Field
      value={value || null}
      label={label}
      name={name}
      data-test-id="note-code-select"
      component={Autocomplete}
      required={required}
      options={options.sort((a, b) => a.name.localeCompare(b.name))}
      onChange={(e) => {
        setFieldValue(
          name,
          options.find((item) => item?.id == e?.target?.value)?.name || null,
        )
      }}
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          const code = options.find((item) => item?.name == option)
          return `${code?.name} - ${code?.description}`
        }
        return `${option?.name} - ${option?.description}`
      }}
      isOptionEqualToValue={(option, value) =>
        option?.name === (value.name || value)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{ width: selectWidth || '350px' }}
          label={label}
          avoidDisplayingErrorIcon
          required={required}
          inputProps={{
            ...params.inputProps,
            name: name,
          }}
          error={error}
        />
      )}
      renderOption={(props, code: NoteCode) => (
        <MenuItem {...props} key={code.id} value={code.id}>
          {code.name} - {code.description}
        </MenuItem>
      )}
      error={error}
    />
  )
}
